import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { CONTRIBUTORS, MODES, ORDER_METRICS } from '../scope';

/**
 * This report's own scope controls, laid out in the shared control grid beside the property and
 * the dates: which topic the trend and the contributors are about, how the topics are ordered,
 * which metric that order reads, and whether block 04 lists queries or pages.
 *
 * The topic list is the session's own topics, read from the definitions being written below — a
 * topic that has been added but not applied is already pickable, because Apply sends the two
 * together.
 */
function ExtraControls({ t, draft, onChange }) {
    const topicOptions = draft.topics.map((topic) => ({ value: topic.name, label: topic.name }));
    const topicValue =
        topicOptions.find((item) => item.value === draft.topic) ?? topicOptions[0] ?? null;

    const modeOptions = MODES.map((value) => ({
        value,
        label: t(`tools.topic_clusters.modes.${value}`),
    }));
    const metricOptions = ORDER_METRICS.map((value) => ({
        value,
        label: t(`tools.gsc.metrics.${value}_short`),
    }));
    const contributorOptions = Object.values(CONTRIBUTORS).map((value) => ({
        value,
        label: t(`tools.topic_clusters.contributors.views.${value}`),
    }));

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.topic_clusters.controls.topic')}</label>
                <ReactSelect
                    options={topicOptions}
                    value={topicValue}
                    blurInputOnSelect={true}
                    disabled={!topicOptions.length}
                    placeholder={t('tools.topic_clusters.controls.topic_none')}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ topic: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.topic_clusters.controls.topic_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.topic_clusters.controls.mode')}</label>
                <ReactSelect
                    options={modeOptions}
                    value={modeOptions.find((item) => item.value === draft.mode)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ mode: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t(`tools.topic_clusters.controls.mode_note.${draft.mode}`)}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.topic_clusters.controls.metric')}</label>
                <ReactSelect
                    options={metricOptions}
                    value={metricOptions.find((item) => item.value === draft.metric)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ metric: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.topic_clusters.controls.metric_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.topic_clusters.controls.contributors')}</label>
                <ReactSelect
                    options={contributorOptions}
                    value={contributorOptions.find((item) => item.value === draft.contributors)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ contributors: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t(`tools.topic_clusters.contributors.aggregation.${draft.contributors}`)}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
